import { useQuery } from '@tanstack/react-query'

import { responsibleMedicalRecordInstance } from '../..'

export function getResponsibleMedicalRecordQueryKey(id: string) {
  return ['responsibleMedicalRecord', id]
}

export function useResponsibleMedicalRecordQuery({
  id,
  enabled
}: {
  id: string
  enabled?: boolean
}) {
  return useQuery({
    queryKey: getResponsibleMedicalRecordQueryKey(id),
    queryFn: async () =>
      await responsibleMedicalRecordInstance.getResponsibleMedicalRecord({
        id
      }),
    enabled
  })
}
